import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { FeaturedCategories } from '../components/FeaturedCategories';
import { AIGeneratorSection } from '../components/AIGeneratorSection';
import { ProjectsMasonry } from '../components/ProjectsMasonry';
import { MakerCommunity } from '../components/MakerCommunity';
import { InteractiveTools } from '../components/InteractiveTools';
import { ModernContent } from '../components/ModernContent';
import { ShoppingSection } from '../components/ShoppingSection';
import { MarketplaceTeaser } from '../components/MarketplaceTeaser';
import { FloatingAIAssistant } from '../components/FloatingAIAssistant';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-soft dark:bg-navy-900 transition-colors duration-300" data-id="element-335">
      <Navbar data-id="element-336" />
      <main data-id="element-337">
        <section id="hero" data-id="element-338">
          <HeroSection data-id="element-339" />
        </section>
        <section id="categories" data-id="element-340">
          <FeaturedCategories data-id="element-341" />
        </section>
        <section id="ai-generator" data-id="element-342">
          <AIGeneratorSection data-id="element-343" />
        </section>
        <section id="projects" data-id="element-344">
          <ProjectsMasonry data-id="element-345" />
        </section>
        <section id="community" data-id="element-346">
          <MakerCommunity data-id="element-347" />
        </section>
        <section id="tools" data-id="element-348">
          <InteractiveTools data-id="element-349" />
        </section>
        <section id="content" data-id="element-350">
          <ModernContent data-id="element-351" />
        </section>
        <section id="shopping" data-id="element-352">
          <ShoppingSection data-id="element-353" />
        </section>
        <section id="marketplace" data-id="element-354">
          <MarketplaceTeaser data-id="element-355" />
        </section>
      </main>
      <Footer data-id="element-356" />
      <FloatingAIAssistant data-id="element-357" />
    </div>;
}